module.exports = __webpack_public_path__ + "media/slide2-click-action.58b8a93f.mp4";